import styled from 'styled-components';
import { rgba } from 'polished';

import { Market } from '#/api/markets';

import { cCC38FF } from '#/colors';

// WIP: These values to be retrieved from API, when APIs become available
const MARKET_LEVERAGE_MAP: Record<Market['symbol'], string> = {
  'BTC-USD-PERP': '20',
  'ETH-USD-PERP': '20',
  'XRP-USD-PERP': '10',
  'LINK-USD-PERP': '10',
  'SOL-USD-PERP': '10',
  'AVAX-USD-PERP': '10',
};

interface Props {
  market: { symbol: string };
}

export default function Leverage(props: Props) {
  const { market } = props;
  const leverage = MARKET_LEVERAGE_MAP[market.symbol];

  if (leverage == null) return <Empty />;

  return <Container>{leverage}x</Container>;
}

const Empty = styled.div``;

const Container = styled.div`
  height: 14px;
  width: 28px;
  display: grid;
  place-items: center;
  border-radius: 4px;
  background-color: ${rgba(cCC38FF, 0.2)};

  color: ${cCC38FF};
  font-size: 10px;
  font-weight: bold;
`;
